import CalendarComponent from "../../components/calendar/CalendarComponent";
import React from 'react';

export default function CalendarPage() {
  const today = new Date();
  return (
    <CalendarComponent 
        view="month" 
        day={today.getDate().toString()} 
        month={today.getMonth().toString()} 
        year={today.getFullYear().toString()} 
    />
  );
}